export const heroStats = [
  { value: "18년", label: "수학 전문 운영" },
  { value: "1:6", label: "소수정예 정원" },
  { value: "1,200+", label: "누적 재원생" },
  { value: "98%", label: "재등록률" },
];

export const marqueeItems = [
  "소수정예 1:6 밀착관리",
  "주간 오답 클리닉",
  "월간 성적 리포트",
  "입학테스트 진단",
  "초·중·고 전 학년",
  "내신 · 수능 대비",
];

export const features = [
  {
    icon: "ri-group-line",
    title: "소수정예 밀착관리",
    desc: "한 반 최대 6명. 학생마다 질문할 시간이 끝까지 보장되는 수업입니다.",
    role: "primary",
  },
  {
    icon: "ri-stack-line",
    title: "3단계 커리큘럼",
    desc: "교과 개념 → 유형 정리 → 심화 응용까지 끊김 없이 이어지는 학습 설계.",
    role: "accent",
  },
  {
    icon: "ri-edit-2-line",
    title: "주간 오답 클리닉",
    desc: "틀린 문제의 원인을 분석해 매주 다시 풀고, 취약 유형을 없앱니다.",
    role: "secondary",
  },
  {
    icon: "ri-line-chart-line",
    title: "월간 성적 리포트",
    desc: "학습 현황과 향상 폭을 학부모님께 매달 리포트로 투명하게 공유합니다.",
    role: "accent",
  },
  {
    icon: "ri-file-list-3-line",
    title: "입학테스트 진단",
    desc: "현재 실력을 정확히 진단하고, 수준에 맞는 반을 배정해 드립니다.",
    role: "primary",
  },
  {
    icon: "ri-user-heart-line",
    title: "담임 1:1 코칭",
    desc: "전담 선생님이 학습 습관과 시험 대비 전략까지 책임지고 코칭합니다.",
    role: "secondary",
  },
];

export const levels = [
  {
    key: "elementary",
    tag: "ELEMENTARY",
    name: "초등부",
    headline: "수학의 기초 체력",
    desc: "연산 정확도와 사고력을 함께 키우고, 서술형 평가까지 미리 대비합니다.",
    points: ["연산 · 개념 완성", "사고력 · 서술형 대비", "주 1회 오답 점검"],
    image:
      "/uploads/site/mbhj-level-elementary-01.jpg",
  },
  {
    key: "middle",
    tag: "MIDDLE",
    name: "중등부",
    headline: "내신의 시작",
    desc: "학교 시험 범위에 맞춘 내신 대비와 심화 유형 훈련으로 등급을 올립니다.",
    points: ["중간 · 기말 내신 대비", "심화 유형 집중", "시험 전 모의 점검"],
    image:
      "/uploads/site/mbhj-level-middle-01.jpg",
  },
  {
    key: "high",
    tag: "HIGH",
    name: "고등부",
    headline: "수능까지 연결",
    desc: "수Ⅰ·수Ⅱ·미적분 개념을 탄탄히 세우고, 목표 등급에 맞춰 관리합니다.",
    points: ["수Ⅰ · 수Ⅱ · 미적분", "등급 목표 관리", "모의고사 성취 분석"],
    image:
      "/uploads/site/mbhj-level-high-01.jpg",
  },
];

export const results = [
  { value: "4.8점", label: "평균 성적 향상", sub: "3개월 기준" },
  { value: "92%", label: "목표 등급 달성", sub: "학기별 집계" },
  { value: "1,200+", label: "누적 재원생", sub: "2019년 이후" },
];

export const testimonials = [
  {
    name: "김○서 학부모",
    grade: "중2 재원",
    quote:
      "수포자였던 아이가 오답 클리닉을 거치면서 스스로 문제를 풀기 시작했어요. 매달 오는 리포트로 학습 상태를 알 수 있어 안심됩니다.",
  },
  {
    name: "이○준 학생",
    grade: "고1 재원",
    quote:
      "6명뿐이라 모르는 게 있으면 그 자리에서 바로 물어볼 수 있어요. 미적분 개념이 확실히 잡히니까 모의고사 점수도 올랐습니다.",
  },
  {
    name: "박○아 학부모",
    grade: "초6 재원",
    quote:
      "연산 실수가 많았는데 선생님이 하나하나 잡아주셔서 시험에서 실수가 확 줄었어요. 아이가 수학을 좋아하게 됐습니다.",
  },
];